<template>
  <svg v-if="mdSvg" class="md-icon" :width="size || 24" :height="size || 24" :viewBox="viewbox || '0 0 24 24'">
    <path :fill-rule="fillRule" :d="mdSvg" />
  </svg>
  <i class="md-icon" :class="[themeClass, mdIconset]" :aria-hidden="!!mdIconset" v-else>
    <slot></slot>
  </i>
</template>

<style lang="scss" src="./mdIcon.theme"></style>
<style lang="scss" src="./mdIcon.scss" scoped></style>

<script>
import theme from '../../core/theme/mixins';

export default {
  name: 'md-icon',
  props: {
    mdSvg: String,
    size: Number,
    fillRule: String,
    viewbox: String,
    mdIconset: {
      type: String,
      default: 'material-icons',
    },
  },
  mixins: [theme],
};
</script>
